<dx-toolbar class="dashboard-toolbar">
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row mr-4 items-center">
        <!--<span class="block mr-2 text-sm font-medium">Date: </span>-->
        <dx-select-box
          stylingMode="underlined"
          width="140"
          displayExpr="label"
          valueExpr="value"
          placeholder="Groupe"
          [value]="0"
          (onValueChanged)="selectGroup($event)"
          [items]="groups">
        </dx-select-box>
      </div>
    </div>
  </dxi-item>
</dx-toolbar>
